export default "__VITE_ASSET__CD5TUxT7__"